import { VF_SUB_SECTION_TITLE } from 'AppSrc/core/components/forms/form-base-components/v-f-sub-section-title';

const fieldId = 'sst-select-network';

const validator = () => null;

const vFParams = {
  fieldTitle: 'Select network',
};

const sstSelectNetwork = {
  id: fieldId,
  validator,
  vFParams,
  fieldType: VF_SUB_SECTION_TITLE,
};

export { sstSelectNetwork };
